<template>
  <el-dialog
      title="请输入图片地址"
      :visible.sync="dialogVisible"
      width="30%"
      >
    <el-input v-model="imgSrc"></el-input>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="sure">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      imgSrc:'https://img0.baidu.com/it/u=1049144354,3589714554&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    };
  },
  methods: {
    setDialogVisible(value) {
      this.dialogVisible = value
    },
    sure(){
      if(this.imgSrc){
        this.dialogVisible = false ;
        this.$emit('setChangeImgSrc',this.imgSrc)
      }


    }
  }
};
</script>
